// Visibility levels for settings.
//
// This is deliberately separate from the gameplay `Role` model: "mod" is for
// server/game-mode decisions, while this ladder decides which settings appear in
// the UI. `access` on a setting is the minimum level that may see it.

import { canRole, type Role } from "../admin";

export type SettingAccess = "none" | "player" | "tester" | "admin";

export const SETTING_ACCESS: SettingAccess[] = ["none", "player", "tester", "admin"];

/** Role required to see a setting at each access level. */
const ACCESS_ROLE: Record<Exclude<SettingAccess, "none">, Role> = {
  player: "player",
  tester: "tester",
  admin: "admin",
};

export function canSeeSetting(access: SettingAccess, role: Role): boolean {
  if (access === "none") return false;
  return canRole(role, ACCESS_ROLE[access]);
}

/** Admin editors show hidden ("none") settings too, so they can be re-enabled. */
export function canAdminSeeSetting(access: SettingAccess): boolean {
  return access === "none" || SETTING_ACCESS.includes(access);
}

export function normalizeAccess(value: unknown): SettingAccess {
  return value === "none" || value === "player" || value === "tester" || value === "admin"
    ? value
    : "player";
}
